import gql from 'graphql-tag';

const REQUEST_DISPLAY_REPORT_FULL = gql`
  mutation getFullDisplayReport($campaignOrderId: String!) {
    getFullDisplayReport(campaignOrderId: $campaignOrderId)
  }
`;

export default REQUEST_DISPLAY_REPORT_FULL;
